import {put, takeLatest} from 'redux-saga/effects';
import * as actions from './../actions';
import * as paths from './../../paths';
import RequestManager from "../../utils/RequestManager";
import {marketingOffer} from "../actions/actionTypes";

export function* getMarketingOfferSaga(action) {
    const axios = yield RequestManager.getAxiosWithToken();
    try {

        let data = {
            productId: action.productId ? action.productId : 1
        };

        if (action.moid) {
            data.moid = action.moid
        }

        const response = yield axios({
            url: paths.marketing_offer.GET,
            method: 'post',
            data: data,
        });

        if (!response) {
            throw new Error(`[ERROR] Send Email response is empty!`);
        }

        if (!response.hasOwnProperty('result')) {
            throw new Error(`[ERROR] Send Email response has no 'result' property`);
        }

        yield put(actions.setMarketingOffer(response.result));
    } catch (error) {
        console.log(error);
        return;
    }
}

export default function* watchMarketingOfferSaga() {
    yield takeLatest(marketingOffer.GET,getMarketingOfferSaga);
}